import {
    RESET_USER_PASSWORD_ERROR,
    RESET_USER_PASSWORD_START,
    RESET_USER_PASSWORD_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.user.reset, action = {type: ''}) => {
    switch (action.type) {
        case RESET_USER_PASSWORD_START:
            return {
                error: false,
                loading: true,
                success: false,
            };
        case RESET_USER_PASSWORD_SUCCESS:
            return {
                error: false,
                loading: false,
                success: true,
            };
        case RESET_USER_PASSWORD_ERROR:
            return {
                error: true,
                loading: false,
                success: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer/resetUserPasswordReducer.js